import React from "react";
import { Control, useFieldArray, Controller } from "react-hook-form";
import { Box, Button, Input, Text } from "rizzui";
import { PiPlusBold, PiTrashBold } from "react-icons/pi";
import { FormData } from "../types";

interface LTVSectionProps {
  control: Control<FormData>;
}

const LTVSection: React.FC<LTVSectionProps> = ({ control }) => {
  const {
    fields: ltvFields,
    append: ltvAppend,
    remove: ltvRemove,
  } = useFieldArray({
    control,
    name: "housingLoanLTV",
  });

  return (
    <Box>
      <div className="pb-6 md:p-6 border-b border-gray-200">
        <h3 className="text-lg font-semibold">Housing Loan LTV Limits</h3>
        <Text className="text-sm text-gray-600 mt-1">
          Configure Loan-to-Value limits based on existing housing loans
        </Text>
      </div>
      <div className="pt-6 md:p-6 space-y-4">
        {ltvFields.map((field, index) => (
          <div key={field.id} className="border rounded-lg p-4 space-y-4">
            <div className="flex items-center justify-between">
              <Controller
                name={`housingLoanLTV.${index}.loanCount`}
                control={control}
                render={({ field }) => (
                  <Input
                    {...field}
                    placeholder="0 / 1 / 2+"
                    className="font-medium"
                  />
                )}
              />
              {ltvFields.length > 1 && (
                <Button
                  variant="text"
                  color="danger"
                  size="sm"
                  onClick={() => ltvRemove(index)}
                >
                  <PiTrashBold className="h-4 w-4" />
                </Button>
              )}
            </div>
            <Controller
              name={`housingLoanLTV.${index}.ltv`}
              control={control}
              render={({ field }) => (
                <div>
                  <Text className="text-sm font-medium mb-1">LTV (%)</Text>
                  <Input
                    type="number"
                    {...field}
                    onChange={(e) => field.onChange(Number(e.target.value))}
                    placeholder="75"
                  />
                </div>
              )}
            />
          </div>
        ))}
        <Button
          variant="flat"
          onClick={() => ltvAppend({ loanCount: "", ltv: 0 })}
          className="w-full"
        >
          <PiPlusBold className="h-4 w-4 mr-2" />
          Add LTV Limit
        </Button>
      </div>
    </Box>
  );
};

export default LTVSection;
